import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	recognise : {
		published   : [],
		unpublished : [],
		recognise   : false

	}
};

export const recogniseSlice = createSlice({
	name     : 'recognise',
	initialState,
	reducers : {
		fetchRecogniseData : (state, action) =>
		{
			state.recognise = { ...state.recognise, ...action.payload };
		}

	}
});

export const { fetchRecogniseData } = recogniseSlice.actions;
export default recogniseSlice.reducer;
